import React, { useState } from "react";
import { IService, IServiceCategory } from "app/api/types";
import EditServiceForm from "app/components/EditServiceForm";

import "./styles.scss";

interface IProps {
  serviceCategoriesList: IServiceCategory[];
  service: IService;
  onSubmit: (data: IService) => void;
  onDelete: (id: IService["id"]) => void;
}

const Service: React.FC<IProps> = (props) => {
  const [isCollapsed, setCollapse] = useState(true);
  const [isDeleting, setDelete] = useState(false);

  const triggerCollapse = () => {
    setCollapse(!isCollapsed);
  };

  const onDelete = () => {
    setDelete(true);
    props.onDelete(props.service.id);
  };

  const styles = {
    height: !isCollapsed ? "479px" : "60px",
  };

  return (
    <div
      className={`phrase-container ${isDeleting ? "deleting" : ""}`}
      style={styles}
    >
      <div className="phrase-wrapper">
        <div className="left-block" onClick={triggerCollapse}>
          <div className="phrase-text">{props.service.title}</div>
          <div className="phrase-translation"></div>
        </div>

        <div className="right-block">
          <p className="phrase-del" onClick={onDelete}>
            удалить
          </p>
        </div>
      </div>

      <EditServiceForm
        serviceCategoriesList={props.serviceCategoriesList}
        service={props.service}
        onSubmit={props.onSubmit}
        isActive={!isCollapsed}
      />
    </div>
  );
};

export default Service;
